<template>
  <div class="page-wrapper">
    <div class="page-head">

      <div class="breadcrumbs">
        <div class="h1" v-if="$route.path.includes('bookkeeping')">
          <router-link class="link-not-like" to="/bookkeeping">{{ $vuetify.lang.t('$vuetify.menu.accounting') }}
          </router-link>
        </div>
        <svg v-if="$route.path.includes('bookkeeping')" width="9" height="15" viewBox="0 0 9 15" fill="none"
             xmlns="http://www.w3.org/2000/svg">
          <path d="M1.27539 13.7068L7.48229 7.49989L1.27539 1.29299" stroke="#2C1521" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <h1>{{ $vuetify.lang.t('$vuetify.menu.absence') }}</h1>
        <svg v-if="name" width="9" height="15" viewBox="0 0 9 15" fill="none"
             xmlns="http://www.w3.org/2000/svg">
          <path d="M1.27539 13.7068L7.48229 7.49989L1.27539 1.29299" stroke="#2C1521" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <div class="h1" v-if="name">
          {{ name }}
        </div>
      </div>

      <div class="page-head__btns">
        <BookkeepingSelect v-if="$route.path.includes('bookkeeping')" :mode="'documents-absense'"></BookkeepingSelect>


        <button v-if="active"
                class="btn-secondary btn"
                @click="action = 'add'; absence_create_open()">
          + {{ $vuetify.lang.t('$vuetify.add') }}
        </button>
      </div>
    </div>
    <div class="page-head">
      <div class="page__sorts">
        <v-menu ref="date" v-model="menus.range" :close-on-content-click="false" transition="scale-transition">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field class="search-field" :value="range.join(' ~ ')"
                          @keypress.enter="loadData()" prepend-inner-icon="$calendar"
                          :placeholder="$vuetify.lang.t('$vuetify.date')" outlined
                          hide-details v-bind="attrs" v-on="on" readonly clearable @click:clear="range=[]; loadData()">
            </v-text-field>
          </template>
          <v-date-picker v-model="range" no-title first-day-of-week="1" show-week locale-first-day-of-year="4"
                         show-adjacent-months
                         range @input="range.length === 2 ? menus.range = false : menus.range = true"
                         :value="range.join(' ~ ')"
          ></v-date-picker>
        </v-menu>
        <v-text-field class="search-field"
                      v-model="search" @keypress.enter="loadData()"
                      :placeholder="$vuetify.lang.t('$vuetify.sorts.searchWorker')"
                      outlined
                      prepend-inner-icon="$search" hide-details>
        </v-text-field>
      </div>
      <div class="page-head--right" v-if="permissions.admin || permissions.read.indexOf('Бухгалтерия') !== -1">
        <div class="type-switcher">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <div class="type-switcher__item type-switcher__item--document" @click="createReport"
                   v-bind="attrs"
                   v-on="on">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M7.80036 13.2004C7.64123 13.2004 7.48862 13.2636 7.3761 13.3761C7.26358 13.4886 7.20036 13.6413 7.20036 13.8004V16.2004C7.20036 16.3595 7.26358 16.5121 7.3761 16.6247C7.48862 16.7372 7.64123 16.8004 7.80036 16.8004C7.95949 16.8004 8.1121 16.7372 8.22463 16.6247C8.33715 16.5121 8.40036 16.3595 8.40036 16.2004V16.0012H8.79996C9.17137 16.0012 9.52757 15.8536 9.7902 15.591C10.0528 15.3284 10.2004 14.9722 10.2004 14.6008C10.2004 14.2294 10.0528 13.8732 9.7902 13.6106C9.52757 13.3479 9.17137 13.2004 8.79996 13.2004H7.80036ZM8.79996 14.8012H8.40036V14.4004H8.79996C8.85311 14.4004 8.90409 14.4215 8.94167 14.4591C8.97925 14.4967 9.00036 14.5476 9.00036 14.6008C9.00036 14.6539 8.97925 14.7049 8.94167 14.7425C8.90409 14.7801 8.85311 14.8012 8.79996 14.8012Z"
                    fill="#2C1521"/>
                  <path
                    d="M14.4004 13.8004C14.4004 13.6413 14.4636 13.4886 14.5761 13.3761C14.6886 13.2636 14.8412 13.2004 15.0004 13.2004H16.2004C16.3595 13.2004 16.5121 13.2636 16.6246 13.3761C16.7371 13.4886 16.8004 13.6413 16.8004 13.8004C16.8004 13.9595 16.7371 14.1121 16.6246 14.2247C16.5121 14.3372 16.3595 14.4004 16.2004 14.4004H15.6004V14.8024H16.2004C16.3595 14.8024 16.5121 14.8656 16.6246 14.9781C16.7371 15.0906 16.8004 15.2433 16.8004 15.4024C16.8004 15.5615 16.7371 15.7141 16.6246 15.8267C16.5121 15.9392 16.3595 16.0024 16.2004 16.0024H15.6004V16.1992C15.6005 16.278 15.5852 16.356 15.5552 16.4289C15.5251 16.5017 15.4811 16.568 15.4255 16.6238C15.3132 16.7366 15.1607 16.8001 15.0016 16.8004C14.8424 16.8007 14.6897 16.7378 14.5769 16.6255C14.4642 16.5132 14.4007 16.3607 14.4004 16.2016V13.8004Z"
                    fill="#2C1521"/>
                  <path
                    d="M11.3992 13.2004C11.24 13.2004 11.0874 13.2636 10.9749 13.3761C10.8624 13.4886 10.7992 13.6413 10.7992 13.8004V16.2004C10.7992 16.3595 10.8624 16.5121 10.9749 16.6247C11.0874 16.7372 11.24 16.8004 11.3992 16.8004H12.0004C12.4778 16.8004 12.9356 16.6107 13.2732 16.2732C13.6107 15.9356 13.8004 15.4778 13.8004 15.0004C13.8004 14.523 13.6107 14.0652 13.2732 13.7276C12.9356 13.39 12.4778 13.2004 12.0004 13.2004H11.3992ZM11.9992 15.6004V14.4004H12.0004C12.1595 14.4004 12.3121 14.4636 12.4246 14.5761C12.5371 14.6886 12.6004 14.8413 12.6004 15.0004C12.6004 15.1595 12.5371 15.3121 12.4246 15.4247C12.3121 15.5372 12.1595 15.6004 12.0004 15.6004H11.9992Z"
                    fill="#2C1521"/>
                  <path
                    d="M4.80036 4.80039C4.80036 4.16387 5.05322 3.55342 5.50331 3.10333C5.95339 2.65325 6.56384 2.40039 7.20036 2.40039H12.7036C13.1808 2.40081 13.6383 2.59073 13.9756 2.92839L18.6736 7.62519C19.0112 7.96243 19.2011 8.41996 19.2016 8.89719V10.8988C19.552 11.0233 19.8553 11.2532 20.0698 11.557C20.2842 11.8609 20.3993 12.2237 20.3992 12.5956V17.3992C20.3992 17.7712 20.2839 18.1341 20.0693 18.438C19.8546 18.7419 19.551 18.9717 19.2004 19.096V19.2004C19.2004 19.8369 18.9475 20.4474 18.4974 20.8974C18.0473 21.3475 17.4369 21.6004 16.8004 21.6004H7.20036C6.56384 21.6004 5.95339 21.3475 5.50331 20.8974C5.05322 20.4474 4.80036 19.8369 4.80036 19.2004V19.096C4.44969 18.9717 4.14613 18.7419 3.93145 18.438C3.71678 18.1341 3.60153 17.7712 3.60156 17.3992V12.5956C3.60162 12.2234 3.71704 11.8604 3.93194 11.5565C4.14685 11.2526 4.45066 11.0229 4.80156 10.8988V4.80039H4.80036ZM18.0004 9.60039H13.8004C13.323 9.60039 12.8651 9.41075 12.5276 9.07318C12.19 8.73562 12.0004 8.27778 12.0004 7.80039V3.60039H7.20036C6.8821 3.60039 6.57688 3.72682 6.35183 3.95186C6.12679 4.17691 6.00036 4.48213 6.00036 4.80039V10.7956H18.0004V9.60039ZM6.00036 19.1992C6.00021 19.3569 6.03113 19.513 6.09136 19.6588C6.1516 19.8045 6.23996 19.9369 6.35141 20.0485C6.46286 20.16 6.5952 20.2486 6.74087 20.3089C6.88653 20.3693 7.04268 20.4004 7.20036 20.4004H16.8004C16.9581 20.4004 17.1142 20.3693 17.2599 20.3089C17.4055 20.2486 17.5379 20.16 17.6493 20.0485C17.7608 19.9369 17.8491 19.8045 17.9094 19.6588C17.9696 19.513 18.0005 19.3569 18.0004 19.1992H6.00036ZM13.2004 3.84879V7.80039C13.2004 7.95952 13.2636 8.11213 13.3761 8.22465C13.4886 8.33718 13.6412 8.40039 13.8004 8.40039H17.752L13.2004 3.84879ZM5.40156 11.9956C5.24243 11.9956 5.08982 12.0588 4.9773 12.1713C4.86478 12.2838 4.80156 12.4365 4.80156 12.5956V17.3992C4.80156 17.5583 4.86478 17.7109 4.9773 17.8235C5.08982 17.936 5.24243 17.9992 5.40156 17.9992H18.6004C18.7595 17.9992 18.9121 17.936 19.0246 17.8235C19.1372 17.7109 19.2004 17.5583 19.2004 17.3992V12.5956C19.2004 12.4365 19.1372 12.2838 19.0246 12.1713C18.9121 12.0588 18.7595 11.9956 18.6004 11.9956H5.40036H5.40156Z"
                    fill="#2C1521"/>
                </svg>
              </div>
            </template>
            <span>{{ $vuetify.lang.t('$vuetify.loadDoc') }}</span>
          </v-tooltip>
        </div>
      </div>
    </div>

    <table class="main-table">
      <thead class="timing-wrap timing__head">
      <td>{{ $vuetify.lang.t('$vuetify.accounting.card.period') }}</td>
      <td>{{ $vuetify.lang.t('$vuetify.accounting.card.worker') }}</td>
      <td>{{ $vuetify.lang.t('$vuetify.reason') }}</td>
      <td>{{ $vuetify.lang.t('$vuetify.comment') }}</td>
      <td class="rows__dot-menu"></td>
      </thead>
      <tbody>
      <tr class="timing-wrap rows__single" :class="{'mobile-show': item.id == notruncate}"
          v-for="item in absence"
          :key="item.id" @click="notruncate == item.id ? notruncate = 0 : notruncate = item.id">
        <td>
          {{ new Date(item.date_start).toLocaleDateString('ru-Ru') }}
          <span v-if="item.date_end"> ~ {{ new Date(item.date_end).toLocaleDateString('ru-Ru') }}
          </span>
        </td>
        <td>
          <router-link v-if="permissions.admin || permissions.read.indexOf('Работники') !== -1"
                       :to="'/workers/' + item.user_profile.id">
            {{ item.user_profile.name }} {{ item.user_profile.lastname }}
          </router-link>
          <span v-else>{{ item.user_profile.name }} {{ item.user_profile.lastname }}</span>
        </td>
        <td>
          {{
            item.reason.name[$vuetify.lang.current] ? item.reason.name[$vuetify.lang.current] : item.reason.name['eng']
          }}
        </td>
        <td class="timing__work">
          <pre :class="{'truncate-text': item.id!==notruncate}">{{ item.comment }}</pre>
        </td>
        <td class="rows__dot-menu">
          <v-menu bottom right
                  v-if="((item.user_profile.auth_user_id.id == worker_id && !item.approved) || permissions.admin) && active">
            <template v-slot:activator="{ on, attrs }">
              <v-btn dark icon v-bind="attrs" v-on="on">
                <svg
                  v-bind="attrs"
                  v-on="on"
                  width="20"
                  height="5"
                  viewBox="0 0 20 5"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="2" cy="2.5" r="2" fill="#2C1521"/>
                  <circle cx="10" cy="2.5" r="2" fill="#2C1521"/>
                  <circle cx="18" cy="2.5" r="2" fill="#2C1521"/>
                </svg>
              </v-btn>
            </template>
            <div class="rows__dot-menu-content">
              <div class="btn-wrap"
                   @click="action='edit';absence_create_open(item)">
                {{ $vuetify.lang.t('$vuetify.edit') }}
                <button class="btn-icon btn-action">
                  <edit-icon></edit-icon>
                </button>
              </div>
              <div class="btn-wrap"
                   @click="confirm_open(item)">
                {{ $vuetify.lang.t('$vuetify.delete') }}
                <button class="btn-icon btn-action">
                  <delete-icon></delete-icon>
                </button>
              </div>
              <div class="btn-wrap" v-if="permissions.admin && !item.approved"
                   @click="action='edit';absence_approve_open(item)">
                {{ $vuetify.lang.t('$vuetify.confirm') }}
                <button class="btn-icon btn-action">
                  <svg class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiBox-root css-1om0hkc" focusable="false"
                       aria-hidden="true" viewBox="0 0 24 24" data-testid="DoneOutlineIcon">
                    <path
                      d="m19.77 5.03 1.4 1.4L8.43 19.17l-5.6-5.6 1.4-1.4 4.2 4.2L19.77 5.03m0-2.83L8.43 13.54l-4.2-4.2L0 13.57 8.43 22 24 6.43 19.77 2.2z"></path>
                  </svg>
                </button>
              </div>
            </div>
          </v-menu>
        </td>
      </tr>
      </tbody>
    </table>

    <v-dialog v-model="absence_create_modal">
      <div class="modal">
        <div class="h1">
          <span v-if="action === 'add'">{{ $vuetify.lang.t('$vuetify.add') }}</span><span
          v-if="action === 'edit'">{{ $vuetify.lang.t('$vuetify.edit') }}</span>
        </div>
        <v-form ref="form" @submit.prevent="" onkeydown="return event.key !== 'Enter';">
          <v-checkbox v-if="permissions.admin" v-model="newAbsence.approved"
                      :label="$vuetify.lang.t('$vuetify.confirm')"></v-checkbox>
          <v-autocomplete v-if="$route.path.includes('bookkeeping') || permissions.admin"
                          v-model="newAbsence.user_profile"
                          :label="$vuetify.lang.t('$vuetify.accounting.card.worker')"
                          :items="profiles" item-text="label" item-value="id"

                          clearable outlined attach
                          :menu-props="{
                                                bottom: true,
                                                offsetY: true,
                                                maxHeight: width<1024 ? 200 : 800,
                                                contentClass: 'select-menu',
                                            }"
          >
            <template v-slot:selection="{ item }">
              {{ item.name }} {{ item.lastname }},
              <template v-if="item.position && item.position.name"> ({{
                  item.position.name[$vuetify.lang.current] ? item.position.name[$vuetify.lang.current] : item.position.name['eng'] ? item.position.name['eng'] : item.position.name['fin']
                }})
              </template>
            </template>
            <template v-slot:item="{ item }">
              {{ item.name }} {{ item.lastname }},
              <template v-if="item.position && item.position.name"> ({{
                  item.position.name[$vuetify.lang.current] ? item.position.name[$vuetify.lang.current] : item.position.name['eng'] ? item.position.name['eng'] : item.position.name['fin']
                }})
              </template>
            </template>
          </v-autocomplete>
          <div class="form__row">
            <v-menu ref="dateStart" v-model="menus.dateStart" :close-on-content-click="false"
                    transition="scale-transition">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="newAbsence.date_start ? new Date(newAbsence.date_start).toLocaleDateString('ru-Ru'): ''"
                  :label="$vuetify.lang.t('$vuetify.date')"
                  append-icon="$calendar" v-bind="attrs" v-on="on"
                  outlined readonly>
                </v-text-field>
              </template>
              <v-date-picker v-model="newAbsence.date_start" no-title first-day-of-week="1" show-week
                             locale-first-day-of-year="4" show-adjacent-months
                             @input="menus.dateStart = false">
              </v-date-picker>
            </v-menu>
            <v-menu ref="dateEnd" v-model="menus.dateEnd" :close-on-content-click="false" transition="scale-transition">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="newAbsence.date_end ? new Date(newAbsence.date_end).toLocaleDateString('ru-Ru'): ''"
                  :label="$vuetify.lang.t('$vuetify.date')"
                  append-icon="$calendar" v-bind="attrs" v-on="on"
                  outlined readonly>
                </v-text-field>
              </template>
              <v-date-picker v-model="newAbsence.date_end" no-title first-day-of-week="1" show-week
                             locale-first-day-of-year="4" show-adjacent-months
                             @input="menus.dateEnd = false">
              </v-date-picker>
            </v-menu>
          </div>
          <v-autocomplete v-model="newAbsence.reason"
                          :items="reasons" item-text="label"
                          item-value="id"
                          :label="$vuetify.lang.t('$vuetify.reason')" outlined attach
                          :rules="[$rules.required]"
                          :menu-props="{
          bottom: true,
          offsetY: true,
          maxHeight: width<1024 ? 200 : 800,
          contentClass: 'select-menu',
          }">
            <template v-slot:selection="{ item }">
              {{
                item.name[$vuetify.lang.current] ? item.name[$vuetify.lang.current] : item.name['eng'] ? item.name['eng'] : item.name['fin']
              }}
            </template>
            <template v-slot:item="{ item }">
              {{
                item.name[$vuetify.lang.current] ? item.name[$vuetify.lang.current] : item.name['eng'] ? item.name['eng'] : item.name['fin']
              }}
            </template>
          </v-autocomplete>
          <v-textarea :label="$vuetify.lang.t('$vuetify.comment')" v-model="newAbsence.comment"
                      outlined></v-textarea>
          <div class="error--text" v-if="alertError">{{ alertMsg }}</div>
          <div class="sign-up__buttons btn-group">
            <button class="btn btn-secondary" @click="absence_create_close">
              {{ $vuetify.lang.t('$vuetify.cancel') }}
            </button>
            <button class="btn btn-primary" @click="addAbsence">
              {{ $vuetify.lang.t('$vuetify.save') }}
            </button>
          </div>
        </v-form>
      </div>
    </v-dialog>

    <ConfirmModal v-model="confirm_modal" @confirm="deleteAbsence">
      <span v-if="alertError">{{ alertMsg }}</span>
    </ConfirmModal>

    <SpinnerLoader :overlay="loader"></SpinnerLoader>
  </div>
</template>

<script>
import ConfirmModal from "@/components/confirmModal";
import EditIcon from "@/components/icons/EditIcon";
import DeleteIcon from "@/components/icons/DeleteIcon";
import SpinnerLoader from "@/components/SpinnerLoader";
import {mapGetters} from "vuex";
import BookkeepingSelect from "@/components/BookkeepingSelect.vue";

export default {
  name: "AbsenceList",
  components: {BookkeepingSelect, SpinnerLoader, DeleteIcon, EditIcon, ConfirmModal},
  props: {
    worker: [Number, String, undefined]
  },
  data() {
    return {
      name: "",
      sort: '',
      search: "",
      range: [],
      absence: [],
      reasons: [],
      profiles: [],
      worker_id: 0,

      notruncate: 0,
      action: '',
      absence_create_modal: false,
      newAbsence: {
        date_start: '',
      },
      menus: {
        range: false,
        dates: false,
        dateStart: false,
        dateEnd: false,
      },

      tmp_delete: {},
      confirm_modal: false,
      alertMsg: "",
      alertError: false,
      loader: false,
      width: screen.width,
    }
  },

  watch: {
    sort: function () {
      this.loadData()
    },
    range: function () {
      if (this.range.length === 2)
        this.loadData()
    },
  },

  created: function () {
    this.url = "time-tracking/absence"
    if (this.$route.path.includes('bookkeeping')) {
      this.url = "time-tracking/accounting/absence"
    }
    this.loadProfiles()
    this.loadData()
    this.loadReasons()
  },

  methods: {
    loadData() {
      this.loader = true
      this.$axios({
        url: this.$hostname + this.url,
        method: "GET",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
        },
        params: {
          sort: this.sort,
          range: JSON.stringify(this.range),
          search: this.search,
        },
      }).then((response) => {
        this.absence = response.data.data.data
        this.worker_id = response.data.data.worker_id
      }).catch((response) => {
        this.alertMsg = this.$catch(response)
        this.alertError = true
      }).then(() => {
        this.loader = false
      })
    },
    loadReasons() {
      this.$axios({
        url: this.$hostname + "time-tracking/absence/reasons",
        method: "GET",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
        },
      }).then((response) => {
        this.reasons = response.data.data.data
        this.reasons.forEach(reason => {
          reason.label = reason.name[this.$vuetify.lang.current] ? reason.name[this.$vuetify.lang.current] : reason.name['en']
        })
      }).catch((response) => {
        this.alertMsg = this.$catch(response)
        this.alertError = true
      })
    },
    loadProfiles() {
      this.$axios({
        url: this.$hostname + "time-tracking/profiles/active",
        method: "GET",
        headers: {
          'Authorization': 'Token ' + (localStorage.getItem('auth_token') || sessionStorage.getItem('auth_token')),
        },
      }).then((response) => {
        this.profiles = response.data.data.data
        this.profiles.forEach(user => {
          user.label = user.lastname + ' ' + user.name + ', ' + user.position.name
        })
      }).catch((response) => {
        this.alertMsg = this.$catch(response)
        this.alertError = true
      })
    },

    addAbsence() {
      if (this.$refs.form.validate()) {
        if (this.newAbsence.id) {
          this.putAbsence()
        } else {
          if (this.worker) {
            this.newAbsence.user_profile = this.worker
          }
          this.$axios({
            url: this.$hostname + "time-tracking/absence",
            method: "POST",
            headers: {
              Authorization:
                "Token " +
                (localStorage.getItem("auth_token") ||
                  sessionStorage.getItem("auth_token")),
              "Content-Type": "multipart/form-data",
            },
            data: {
              user_profile: this.newAbsence.user_profile,
              date_start: this.newAbsence.date_start,
              date_end: this.newAbsence.date_end,
              reason: this.newAbsence.reason,
              comment: this.newAbsence.comment,
              approved: this.newAbsence.approved
            },
          }).then(() => {
            this.loadData()
            this.absence_create_close()
          }).catch((response) => {
            this.alertMsg = this.$catch(response)
            this.alertError = true
          })
        }
      } else {
        this.alertMsg = this.$vuetify.lang.t("$vuetify.fillForm")
        this.alertError = true
      }
    },
    putAbsence() {
      this.$axios({
        url: this.$hostname + "time-tracking/absence",
        method: "PUT",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
          "Content-Type": "multipart/form-data",
        },
        data: {
          id: this.newAbsence.id,
          user_profile: this.newAbsence.user_profile.id,
          date_start: this.newAbsence.date_start,
          date_end: this.newAbsence.date_end,
          reason: this.newAbsence.reason,
          comment: this.newAbsence.comment,
          approved: this.newAbsence.approved
        },
      }).then(() => {
        this.loadData()
        this.absence_create_modal = false
      }).catch((response) => {
        this.alertMsg = this.$catch(response)
        this.alertError = true
      })
    },
    deleteAbsence() {
      this.$axios({
        url: this.$hostname + "time-tracking/absence",
        method: "DELETE",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
          "Content-Type": "multipart/form-data",
        },
        data: {
          id: this.tmp_delete.id,
          user_profile: this.tmp_delete.user_profile.id
        },
      }).then(() => {
        this.loadData()
        this.confirm_modal = false
      }).catch((response) => {
        this.alertMsg = this.$catch(response)
        this.alertError = true
      })
    },

    absence_create_open(item = null) {
      this.absence_create_modal = true;
      this.alertError = false

      if (this.action === "edit") {
        this.newAbsence = item
      } else {
        this.newAbsence = {
          date_start: new Date().toISOString().substring(0, 10),
        };
      }
    },
    absence_approve_open(item = null) {
      this.alertError = false
      this.newAbsence = item
      this.newAbsence.dates = [item.date_start, item.date_end]
      this.newAbsence.approved = true
      this.absence_create_modal = true
    },
    absence_create_close() {
      this.absence_create_modal = false;
    },
    confirm_open(item) {
      this.tmp_delete = item
      this.confirm_modal = true
      this.alertError = false
    },

    createReport() {
      this.loader = true
      this.$axios({
        url: this.$hostname + "time-tracking/absence/pdf",
        method: "GET",
        headers: {
          Authorization:
            "Token " +
            (localStorage.getItem("auth_token") ||
              sessionStorage.getItem("auth_token")),
        },
        params: {
          sort: this.sort,
          range: JSON.stringify(this.range),
          search: this.search,
        },
      }).then((response) => {
        let path = response.data.data.data
        var link = document.createElement('a')
        link.href = this.$media_url + path
        link.target = "_blank"
        document.body.appendChild(link);
        link.click()
      }).catch((response) => {
        this.alertMsg = this.$catch(response)
        this.alertError = true
      }).then(() => {
        this.loader = false
      })
    },
  },

  computed: {
    ...mapGetters(['permissions']),
    ...mapGetters(['active']),
  }
}
</script>

<style scoped>

</style>